<mat-tab-group (selectedIndexChange)="initTabDatasource($event)" disableRipple class="dialog-table" mat-stretch-tabs="false">
  @if (dataSource && dataSource !== undefined) {
    @for (tab of tabs; track tab) {
      <mat-tab [label]="tab | upperfirst | removeUnderscore">
        <div class="row utils-bar" style="justify-content: space-between">
          @if (dataSource[tab]) {
            <div class="table-filter">
              <input (keyup.enter)="applyFilter(tab, $event.target.value)" placeholder="Search"/>
            </div>
          }
          <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200]" [pageSize]="20"
          length="{{dataSource[tab] ? dataSource[tab].data?.length : 0}}" showFirstLastButtons></mat-paginator>
        </div>
        <div class="table-container">
          @if (dataSource[tab]!==undefined) {
            <table [dataSource]="dataSource[tab]" [matSortActive]="columns[0]"
              class="data-exceptions-table table-striped" mat-table matSort matSortDirection="desc">
              @for (column of columns; track column) {
                <ng-container matColumnDef="{{column}}">
                  @switch (true) {
                    <!--Name-->
                    @case (column==='name') {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element;" mat-cell
                        style="text-align: left;border:none;cursor:pointer;display: flex;align-items: center;">
                        <!--<i (click)="editComponentType(component_type)" class="edit-inline hide-xs"></i>-->
                        <div [textContent]="element.attributes.name" style="padding-top:2px;"></div>
                      </td>
                    }
                    <!--Alerts-->
                    @case (column==='alert') {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element" class="large-cell" mat-cell style="text-align: left;border:none;">
                        <div [textContent]="alerts_dict[element.relationships['alert']?.id]?.attributes.name"
                        style="cursor:pointer;padding-top:2px;"></div>
                      </td>
                    }
                    <!--Series-->
                    @case (column==='series') {
                      <th *matHeaderCellDef mat-header-cell>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element" class="large-cell d-flex" mat-cell
                        style="text-align: left;border:none;">
                        <div class="series-column">
                          <i (click)="editSeries(element)" class="edit-inline hide-xs"></i>
                        </div>
                      </td>
                    }
                    <!--Check boxes-->
                    @case (column==='is_muted') {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element;" class="checkbox-cell" mat-cell>
                        <mat-checkbox [(ngModel)]="element.attributes[column]" [disabled]="!can_edit"></mat-checkbox>
                      </td>
                    }
                    <!--Start/End -->
                    @case (column==='start' || column==='end') {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element" mat-cell> {{element.attributes[column] | stringDate}} </td>
                    }
                    <!--Changed on -->
                    @case (column==='changed_on') {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element" mat-cell> {{element.attributes[column] | stringDate}} </td>
                    }
                    <!--Case Else -->
                    @default {
                      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{column | upperfirst | removeUnderscore}}</th>
                      <td *matCellDef="let element" mat-cell> {{element.attributes[column]}} </td>
                    }
                  }
                </ng-container>
              }
              <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
              <tr *matRowDef="let row; columns: columns;" mat-row></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell empty-row-cell" colspan="100%">No data.</td>
              </tr>
            </table>
          }
        </div>
      </mat-tab>
    }
  }
</mat-tab-group>
